module.exports = __webpack_public_path__ + "img/is.f7f66aa0.svg";